function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsctm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.26 21.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M3.6,6.93c.15-.57.3-1.13.45-1.7.27-.98.56-1.95.99-2.88.27-.59.59-1.14,1.05-1.61.37-.37.79-.63,1.31-.71,1.14-.17,2.16.47,2.5,1.58.02.05.04.08.09.1.98.39,1.49,1.49,1.16,2.49-.03.08,0,.12.05.18.54.47.77,1.07.63,1.78-.14.69-.57,1.14-1.24,1.36-.55.18-1.07.07-1.57-.16-.02,0-.04-.02-.07-.04v1.14c0,.25-.15.4-.41.4h-1.59c-.25,0-.4-.15-.4-.4v-1.21c-.21.03-.4.05-.59.07-.1,0-.2.03-.3.03-.2,0-.35-.15-.36-.34,0-.2.14-.36.33-.38.39-.05.78-.1,1.17-.15.31-.04.47.1.47.41v1.24h.94v-1.27c0-.26.16-.42.42-.39.17.02.33.08.5.14.22.07.44.18.66.24.68.15,1.3-.32,1.34-1,.02-.43-.18-.76-.51-1.01-.15-.12-.32-.21-.48-.31.8-.78.23-2.19-.87-2.23-.02-.14-.03-.28-.06-.41-.17-.73-.86-1.21-1.61-1.14-.47.04-.82.29-1.12.64-.42.5-.7,1.07-.95,1.67-.44,1.05-.75,2.13-1.03,3.23-.12.46-.22.93-.34,1.39,0,.03-.01.05-.02.08-.11.3-.41.38-.63.16-.3-.29-.59-.58-.88-.87-.25-.25-.51-.5-.76-.76-.12-.12-.15-.28-.08-.43.07-.14.22-.24.36-.2.09.02.18.07.25.13.37.36.73.72,1.09,1.09.02.02.04.06.06.08l.03-.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M4.64,10.93c.2-.02.39-.03.58-.06.08-.01.15-.06.15-.16,0-.04.02-.08.03-.13.02-.09.08-.11.16-.1.08,0,.08.07.08.13,0,.26,0,.53.02.79,0,.06,0,.11-.08.12-.07,0-.13,0-.15-.09-.05-.27-.11-.31-.41-.31h-.39v.68c0,.22.01.23.23.23h.21c.07,0,.11.03.11.11s-.06.09-.12.09h-1.39c-.06,0-.1-.02-.1-.08,0-.07.02-.11.09-.12.09,0,.19-.01.28-.02.07,0,.11-.04.11-.12v-1.78c0-.11-.04-.14-.15-.15-.07,0-.14,0-.21-.01-.07,0-.13-.02-.13-.11,0-.08.06-.1.13-.09h1.18c.33,0,.67,0,1-.01q.18,0,.25.17c.04.1.09.2.13.31.01.04.02.11,0,.12-.04.02-.1.02-.15,0-.04,0-.07-.04-.1-.07-.27-.25-.58-.39-.97-.33-.11.02-.22,0-.34.01-.05,0-.1.02-.1.08v.88h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M7.91,9.71c.18.03.4.05.62.09.1.01.15.07.15.17s.02.2.03.31c0,.08-.02.13-.1.14-.07,0-.15.04-.18-.08-.07-.25-.22-.38-.48-.38-.15,0-.3.02-.44.06-.1.02-.18.09-.2.21-.02.12.06.2.15.26.17.1.36.18.53.28.22.12.43.25.65.38.03.02.06.05.08.07.26.26.24.57-.05.8-.2.15-.44.21-.68.24-.38.05-.75,0-1.12-.07-.09-.02-.14-.06-.16-.15-.03-.13-.07-.26-.09-.4,0-.05,0-.12.03-.14.05-.03.11-.03.17-.04,0,0,.03.03.04.05.2.57.76.61,1.15.5.06-.02.11-.04.16-.08.15-.11.18-.31.05-.44-.12-.12-.25-.22-.4-.3-.22-.13-.45-.23-.68-.35-.11-.06-.22-.14-.31-.23-.19-.18-.17-.44.03-.61.15-.13.34-.19.54-.22.16-.02.31-.03.51-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M11.51,10.39c-.06-.31-.2-.43-.51-.45-.33-.02-.64.03-.92.24-.21.15-.32.36-.34.62-.03.37.06.7.34.95.27.23.59.3.93.26.17-.02.33-.06.49-.11.17-.05.16-.06.27.09-.17.1-.36.18-.56.21-.42.08-.84.08-1.25-.08-.39-.15-.67-.42-.78-.83-.12-.44.05-.89.44-1.19.36-.27.78-.37,1.23-.38.22,0,.45.02.67.03.16.01.19.05.19.21v.24c0,.17-.03.2-.21.18h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M5.92,15.39v1.03h-.27v-1.61h.33s.05.04.06.07c.12.34.23.69.35,1.03,0,.03.02.06.04.11.02-.05.03-.08.04-.11.12-.34.24-.69.35-1.03.02-.05.04-.08.1-.07h.27v1.61h-.27v-1.02h-.02s-.02.06-.03.09c-.1.29-.2.57-.3.86-.02.06-.05.08-.11.08q-.16,0-.21-.15c-.1-.3-.2-.6-.3-.9h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M1.31,20.44c.09,0,.18-.02.26-.02,0,0,.02,0,.02.02.05.3.41.45.67.27.06-.04.1-.1.08-.17-.02-.05-.06-.12-.11-.13-.13-.05-.26-.08-.39-.12-.08-.03-.17-.05-.24-.09-.26-.14-.3-.48-.08-.68.23-.21.71-.2.93.03.1.1.13.22.13.36-.09,0-.17.02-.25.02,0,0-.01,0-.02-.02-.06-.26-.36-.37-.58-.22-.1.07-.1.21.02.25.12.05.26.07.38.11.1.03.2.06.29.11.24.14.28.45.1.66-.24.28-.83.28-1.07,0-.09-.11-.13-.24-.13-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M8.07,14.81h.3s.06.03.08.05c.11.16.22.31.34.47h.02c.09-.12.2-.24.28-.38.08-.13.17-.18.32-.16h.12s-.04.07-.06.09c-.15.2-.3.4-.45.6-.04.05-.04.08,0,.14.19.25.37.51.56.78h-.34s-.05-.04-.06-.06c-.13-.18-.25-.35-.38-.54-.06.08-.11.15-.16.23-.04.06-.09.11-.12.18-.1.22-.27.24-.49.19.2-.28.41-.55.61-.83-.18-.25-.36-.51-.55-.78l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M4.26,19.89c-.09.02-.18.04-.27.07l-.03-.06c-.06-.16-.16-.26-.33-.26-.2,0-.35.06-.43.24-.09.22-.09.45,0,.67.07.16.23.25.41.24.18,0,.3-.1.36-.27.01-.04.03-.08.04-.13.09.02.18.04.27.07-.03.3-.27.55-.56.58-.55.06-.82-.25-.87-.74-.03-.26.02-.51.21-.7.21-.21.47-.26.75-.2.25.06.39.24.46.49h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    points: "0 19.4 1.11 19.4 1.11 19.66 .29 19.66 .29 20.05 .99 20.05 .99 20.32 .28 20.32 .28 21.01 0 21.01 0 19.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M10.98.29v-.15h.55c.08,0,.19-.02.24.02s.06.15.09.23c.02.05.03.11.06.18.04-.12.08-.22.1-.32.02-.09.06-.14.16-.12h.08v.7h-.15v-.27h-.02c-.03.09-.06.18-.09.28h-.14c-.03-.1-.07-.21-.1-.31h-.02v.3h-.16V.3h-.22v.53h-.17V.3h-.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    x: 7.55,
    y: 14.81,
    width: 0.27,
    height: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1c",
      strokeWidth: 0
    },
    d: "M4.51,19.53c-.06,0-.1,0-.14,0v-.09h.49s.05.03.06.06c.03.06.05.13.08.22.02-.08.04-.13.05-.18.02-.09.06-.13.16-.09v.45h-.09v-.18h-.02s-.02.09-.04.13c-.01.02-.04.06-.07.06-.02,0-.05-.03-.06-.06-.02-.04-.03-.08-.06-.13v.18h-.1v-.36h-.15v.35h-.11v-.36h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsctm);
export default __webpack_public_path__ + "static/media/fsctm.c961cc89a676e96be9eca0cf019c07ed.svg";
export { ForwardRef as ReactComponent };